import React,{Component} from 'react';
import Cookies from "universal-cookie";
import {connect} from 'react-redux';
import { Button, Form, Icon, Modal} from 'semantic-ui-react'
import Loader from 'react-loader-spinner'
import {Host} from '../../config/config'

import './auth.css';

// const Auth = props => {
  class Auth extends Component {

    constructor(props){
      super(props)

      this.CheckAuth=this.CheckAuth.bind(this)
      this.Logout=this.Logout.bind(this)
      this.enterpress=this.enterpress.bind(this)
      this.state  = {
        isFetching:false,
        loginstatus:'',
        loading:false,
        cookies: new Cookies(),
        loginFormDraw:this.props.loginFormDraw,
    
      }
    }


  CheckAuth(e){
      this.setState({isFetching:true})
      fetch('http://'+Host+'/api/ocnitauth/',
          {
        method: 'POST',
        headers: new Headers({
                 'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
                 'Access-Control-Allow-Origin': '*',
        }),
        body: "mode=login&username="+this.loginInput.value+"&passwd="+this.passwordInput.value // <-- Post parameters
          }    )
          .then((response)=>response.json())
            .then((user)=>{
              this.setState({user: user, isFetching:false});
              if(user[0]=='ok'){

                this.setState({userl:'true'+user[1],
                              loginFormDraw:false
                              })
                this.state.cookies.set('sidd', user[1], { path: '/' });
                this.state.cookies.set('usidd', user[2], { path: '/' });
                this.state.cookies.set('access_level', user[3], { path: '/' });

                this.props.authon([user[2], user[1], user[3]]);


              }
              else{this.setState({loginstatus:user[1], logerr:'true',progress:''})}

            }
            );
        this.setState({loading:true})
    }

    Logout(e){
      const cookies = new Cookies();

        fetch('http://'+Host+'/api/ocnitauth/',
            {
          method: 'POST',
          headers: new Headers({
                   'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
                   'Access-Control-Allow-Origin': '*',
          }),
          body: "mode=logout&sidd="+cookies.get('sidd') // <-- Post parameters
            }    )
            cookies.remove('sidd');
            this.props.Logout();
      }

enterpress(e){
  if(e.key === "Enter"){
                this.CheckAuth()
        }
}



  render(){
    const {loginFormDraw} = this.state

      return (
        <div style={{'font-size':'0.9em', 'cursor':'pointer'}}>
          {this.props.auth ?
            <div className='exitlink'><a href={null} onClick={this.Logout}>({this.props.auth[0]}) Выйти </a></div>
            :
            <a href={null} style={{'position':'relative', 'top':'-2px', 'pointer':'cursor'}} onClick={()=>this.setState({loginFormDraw:true})}>Войти</a>
          }

              <Modal open={loginFormDraw}   basic size='small'>
                <Modal.Content>
                {this.state.isFetching ?
                  <div style={{'text-align': 'center'}}>
                  <Loader
                     type="Puff"
                     color="#00BFFF"
                     height="100"
                     width="100"
                  />
                  </div>

                  :
                  ''
                }
                  <Form>
                    <label>Логин:</label>
                      <input type='text' ref={(login) => { this.loginInput = login }} />
                      <label>Пароль:</label>
                      <input type='password' onKeyPress={this.enterpress} ref={(password) => { this.passwordInput = password }} />
                      <div style={{'padding': '12px', 'text-align':'center'}}>
                          <a href={null} onClick={()=>this.setState({loginFormDraw:false})}> close </a>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <Button color='green' inverted onClick={this.CheckAuth}>
                            <Icon name='checkmark' /> Войти
                          </Button>
                      </div>
                  </Form>
                </Modal.Content>

              </Modal>

        </div>

      )
  }
}
export default connect(
  state => ({
    auth:state.auth
    // tempcomments:state.tempcomments
  })
  ,
  dispatch => ({
    authon: (login) => {
      dispatch({ type: 'auth_on' , login:login})
    },
    Logout: () => {
      dispatch({ type: 'auth_off' })
    }
  })
)(Auth);
